interface SideChangeNoticeProps {
  isOpen: boolean;
  winningPoint: number;
  onConfirm: () => void;
}

export default function SideChangeNotice({
  isOpen,
  winningPoint,
  onConfirm,
}: SideChangeNoticeProps) {
  if (!isOpen) return null;

  const midpoint = Math.ceil(winningPoint / 2);

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4">
      <div className="bg-surface border border-warning/30 rounded-2xl p-6 w-full max-w-sm shadow-2xl">
        <div className="text-center mb-6">
          <div className="text-4xl mb-3">↔️</div>
          <h2 className="text-xl font-bold text-warning uppercase tracking-wider mb-2">
            SIDE CHANGE
          </h2>
          <p className="text-sm text-text-secondary mb-4">
            Teams have reached the side change point ({midpoint} points).
          </p>
          <p className="text-sm text-text-primary font-semibold">
            Please change court sides.
          </p>
        </div>

        <button
          onClick={onConfirm}
          className="w-full py-4 px-4 rounded-xl font-bold text-sm bg-warning text-black transition-all hover:opacity-90"
        >
          OK
        </button>
      </div>
    </div>
  );
}
